import { Component, Input, OnInit } from '@angular/core';

import moment from 'moment';

import { PartyTypes } from '@shared/party/enums';
import { numberTypeToStringMap } from '@shared/party/constants';
import { Customer } from '@shared/customer/models';
import { Party } from '@shared/party/models';;
import { FrontendModalService } from '@tablesready/frontend-modal';
import { AppIcon } from '@tablesready/frontend-icons';

@Component({
  selector: 'tablesready-visit-info-customer',
  templateUrl: './visit-info-customer.component.html',
  styleUrls: ['./visit-info-customer.component.scss']
})
export class VisitInfoCustomerComponent implements OnInit{
  icon = AppIcon;
  @Input() customer: Customer & {visits: Party[]};
  @Input() timezone: string;
  @Input() reservationLabel: string;
  avgWait: number;
  lastVisited: string;
  now = Date.now();
  MS_PER_DAY = 24 * 60 * 60 * 1000;
  partyTypes = PartyTypes;
  numberPartyTypeToStringMap = numberTypeToStringMap;

  constructor(
    private readonly modalController: FrontendModalService,
  ) { }

  ngOnInit(): void {
    this.avgWait = this.getAverage(this.customer.visits);
    this.lastVisited = this.customer.lastVisit >= this.now - 15 * 365 * this.MS_PER_DAY ? moment.duration(this.customer.lastVisit - this.now).humanize(true) : 'Unknown';
  }

  getAverage(arr) {
    return arr.reduce((p, c) => p + (c.seated_time - c.checkin_time), 0) / arr.length;
  };

  formatNote(note: string[] | string): string {
    return Array.isArray(note) ? note.join(',') : note;
  }

  cancel (): void {
    this.modalController.dismiss();
  }
}
